// extracted by mini-css-extract-plugin
export default {"person":"PropertyContactInfoPanel_person__P2-SK","personName":"PropertyContactInfoPanel_personName__nWHY6","check":"PropertyContactInfoPanel_check__wq4qX"};